import * as React from 'react';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {dispatch, isFormEmpty, userUniqueID} from '../../utils/generalUtils';
import {Async} from '../reusableComponents/Async';
import {BasePage} from '../reusableComponents/BasePage';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {FileInputButton} from '../reusableComponents/FormComponents/FileInputButton';
import {Loader} from '../reusableComponents/Loader/Loader';
import {OrgForm} from './OrgForm';
import {getOrgDetails, updateOrgInfo} from '../../services/organizationService';
import {IOrgModelProps, OrgModel} from '../../model/OrgModel';

export interface IUpdateOrgProps {
    history: IHistory;
    orgInstance: OrgModel;
    orgId: string;
    orgImageBase64: string;
    Extensions: any;
}

export interface IUpdateOrgState {
    isLoading: boolean;
}

export class UpdateOrgImpl extends React.PureComponent<IUpdateOrgProps,IUpdateOrgState, {}> {
    constructor(props: IUpdateOrgProps) {
        super(props);
        this.state = { isLoading : false};
    }

    public refs: {
        file: FileInputButton;
        orgData: OrgForm;
    };

    public promise = async () => {
        await getOrgDetails(this.props.orgId);
    }

    public handleSubmit = async (values: IOrgModelProps) => {
        if (isFormEmpty(values)) {
            return;
        }
        return await updateOrgInfo(values, this.refs.orgData.orgPic, this.props.history);
    }

    public render() {
        return <BasePage title="Update Organization" icon="building">
            <Async
                identifier="UpdateOrg"
                promise={this.promise}
                loader={<Loader type="async"/>}
                content={
                    <OrgForm
                        loadDefaultValues={() =>
                            dispatch(actions.change('forms.updateOrgForm.OrganizationId', this.props.orgId))}
                        id="UpdateOrg"
                        ref="orgData"
                        instance={this.props.orgInstance}
                        orgImage={this.props.orgImageBase64}
                        model="forms.updateOrgForm"
                        onSubmit={this.handleSubmit}
                    />}
                error={<ErrorPage/>}
            />
            {this.state.isLoading ? <Loader type="submission"/> : ''}
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    return {
        orgInstance: OrgModel.get(ownProps.match.params.id),
        orgId: ownProps.match.params.id,
        orgImageBase64: state.miscellaneous.get('orgImageBase64')
    };
}

export const UpdateOrg = withRouter(connect<{}, {}, IUpdateOrgProps>(mapStateToProps)(UpdateOrgImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Organization/UpdateOrg.tsx